module.exports = __webpack_public_path__ + "3be9ab996df8c883f193eac86979ba14.png";